import React from 'react'

const Header = ({ selected, onSelected, onDelete }) => {
  return (
    <div className='border-b'>
      <div className='py-3 px-8 flex items-center justify-between'>
          { selected.length === 0 ? 
            <h2 className='text-xl font-semibold'>Gallery</h2> : 
            <div className='flex items-center gap-2'>
              <input type="checkbox" className="mr-1 h-4 w-4" checked={selected.length !== 0} onChange={onSelected} />
              <h2 className='text-xl font-semibold'>{selected.length} Files Selected</h2>
            </div> 
          }
        { selected.length !== 0 && 
          <button className='flex items-center gap-1 text-red-600' onClick={onDelete}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
            </svg>
            <span>{ selected.length <= 1 ? 'Delete File' : 'Delete Files' }</span>
          </button>
        }
      </div>
    </div>
  )
}

export default Header